
import { useTranslation } from 'react-i18next';
import { PlanLayout } from "@/components/plans/PlanLayout";
import { OverviewSection } from "@/components/plans/keieisha-hosho/OverviewSection";
import { FinancialDataSection } from "@/components/plans/keieisha-hosho/FinancialDataSection";
import { ResourcesSection } from "@/components/plans/keieisha-hosho/ResourcesSection";

const KeieishaHoshoPage = () => {
  const { t } = useTranslation();
  return (
    <PlanLayout
      title={t('plans_detail.keieisha_hosho.title')}
      imageUrl="https://images.unsplash.com/photo-1450101499163-c8848c66ca85"
    >
      <OverviewSection />
      <FinancialDataSection />
      <ResourcesSection />
    </PlanLayout>
  );
};

export default KeieishaHoshoPage;
